import type { IProspectPhone } from "@apis/prospects/types"
import type { ColumnDef } from "@tanstack/react-table"
import { SetAccountPrimaryPhoneNumberButton } from "../SetAccountPrimaryPhoneNumberButton"
import { DeleteProspectPhoneNumberButton } from "../DeleteProspectPhoneNumberButton"

export const prospectPhoneNumbersColumns = (
  accountId: string,
): ColumnDef<IProspectPhone>[] => {
  return [
    {
      header: "Phone Number",
      cell: ({ row }) => {
        const phone = row.original.phone
        const formattedPhone = phone
          ? phone.replace(/(\d{3})(\d{3})(\d{4})/, "($1) $2-$3")
          : ""
        return <span>{formattedPhone}</span>
      },
    },
    {
      accessorKey: "phone_type",
      header: "Type",
    },
    {
      header: "Primary",
      cell: ({ row }) =>
        row.original.is_primary ? (
          <span>Primary</span>
        ) : (
          <SetAccountPrimaryPhoneNumberButton
            prospectPhoneNumber={row.original}
            accountId={accountId}
          />
        ),
    },
    {
      header: "Remove",
      cell: ({ row }) => (
        <DeleteProspectPhoneNumberButton
          prospectPhoneNumber={row.original}
          accountId={accountId}
        />
      ),
    },
  ]
}
